import React from 'react'
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link } from 'gatsby'

import {
	EliteSection,
	EliteContainer,
	EliteParagraph,
	EliteItemImage,
	EliteDetails,
	EliteCta,
} from './styles'

const EliteDealers = ({ elite, sources, checkedLocale }) => {
	const eliteOptions = {
		renderMarks: {
			[MARKS.BOLD]: text => <Bold>{text}</Bold>,
		},
		renderNode: {
			[BLOCKS.EMBEDDED_ASSET]: node => {
				const asset = node.data && node.data.target && node.data.target.fields
				if (asset === undefined) return
				const { file, description } = asset
				return (
					<Link to={`${checkedLocale}/support/find-a-dealer/`}>
						<EliteItemImage
							src={file['en-AU'].url}
							alt={description['en-AU']}
						/>
					</Link>
				)
			},
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<EliteParagraph>{children}</EliteParagraph>
			),
		},
	}

	return (
		<EliteSection sources={sources}>
			<EliteContainer sources={sources}>
				<EliteDetails>
					{documentToReactComponents(elite.description.json, eliteOptions)}

					<EliteCta to={`${checkedLocale}/support/find-a-dealer/`}>Find a Dealer</EliteCta>
				</EliteDetails>
			</EliteContainer>
		</EliteSection>
	)
}

export default EliteDealers
